// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__vSdE8","modal":"Modal_modal__uVpb6","slide-down":"Modal_slide-down__PM8zd"};